
import Dashboard from '@/views/dashboard/Dashboard.vue'

export default [
  {
    path: 'resumen',
    name: 'resumen',
    component: Dashboard
  }
]
